// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3cxIE","title":"AfterFrontImage_title__1Kwxu"};